const PRINT_BTN_ID = 'report-print-btn';

export const escapeHtml = (s: unknown) => {
  const str = String(s ?? '');
  return str
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
};

const buildPrintableHtml = (title: string, htmlBody: string) => `<!doctype html>
<html lang="sr">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <title>${escapeHtml(title)}</title>
  <style>
    body { font-family: Arial, Helvetica, sans-serif; padding: 24px; color: #111; }
    h1 { margin: 0 0 8px; font-size: 18px; }
    h2 { margin: 18px 0 8px; font-size: 14px; }
    .meta { font-size: 12px; color: #333; margin-bottom: 12px; }
    .meta div { margin: 2px 0; }
    table { width: 100%; border-collapse: collapse; font-size: 11px; }
    th, td { border: 1px solid #ddd; padding: 6px 8px; vertical-align: top; }
    th { background: #f5f5f5; text-align: left; }
    .right { text-align: right; }
    .muted { color: #555; }
    .toolbar { display:flex; justify-content: flex-end; gap: 8px; margin-bottom: 12px; }
    .btn { padding: 8px 10px; border: 1px solid #ddd; background: #fff; cursor: pointer; font-size: 12px; }
    @media print {
      .toolbar { display:none; }
      body { padding: 0; }
    }
  </style>
</head>
<body>
  <div class="toolbar">
    <button type="button" class="btn" id="${PRINT_BTN_ID}">Sačuvaj kao PDF (Print)</button>
  </div>
  ${htmlBody}
</body>
</html>`;

const attachPrintHandler = (w: Window) => {
  const btn = w.document.getElementById(PRINT_BTN_ID);
  if (!btn) return;
  btn.addEventListener('click', () => w.print());
};

/** Opens a printable report in a new tab. Print button works despite CSP (no inline handlers). */
export const openPrintWindow = (title: string, htmlBody: string): boolean => {
  const html = buildPrintableHtml(title, htmlBody);

  try {
    const w = window.open('about:blank', '_blank');
    if (!w) return false;
    w.document.open();
    w.document.write(html);
    w.document.close();
    attachPrintHandler(w);
    return true;
  } catch (err) {
    try {
      const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const w = window.open(url, '_blank');
      if (!w) return false;

      const onReady = () => {
        try {
          attachPrintHandler(w);
        } catch {
          // Opener may lose access on some blob: origins; user can still use Ctrl+P.
        }
      };
      if (w.document?.readyState === 'complete') {
        onReady();
      } else {
        w.addEventListener('load', onReady, { once: true });
      }

      setTimeout(() => URL.revokeObjectURL(url), 60_000);
      return true;
    } catch (e2) {
      // eslint-disable-next-line no-console
      console.error('Failed to open printable report window:', err, e2);
      return false;
    }
  }
};
